export default "__VITE_ASSET__17d9f321__"